// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import RoleCreate from '#core/entities/auth/roles/RoleCreate.ts'
import RoleDetail from '#core/entities/auth/roles/RoleDetail.ts'

/** Company-scoped role management — `GET/POST/PATCH/DELETE /auth/roles/`. */
export default class RolesApi extends Api<RolesApi> {
  constructor() {
    super()
  }

  /** Returns all roles for the current company. */
  async listRoles(): Promise<RoleDetail[]> {
    return (await this.get<RoleDetail[]>('auth/roles/', undefined, RoleDetail)) ?? []
  }

  /** Returns a single role by ID. */
  async getRole(id: string): Promise<RoleDetail | null> {
    return this.get<RoleDetail>(`auth/roles/${id}`, undefined, RoleDetail)
  }

  /** Creates a new role in the current company. */
  async createRole(data: RoleCreate): Promise<RoleDetail | null> {
    return this.post<RoleDetail>('auth/roles/', data, RoleDetail)
  }

  /** Updates an existing role's name, description, and/or permissions. */
  async updateRole(id: string, data: Partial<RoleCreate>): Promise<RoleDetail | null> {
    return this.patch<RoleDetail>(`auth/roles/${id}`, data, RoleDetail)
  }

  /** Deletes a role. Fails if users are still assigned to it. */
  async deleteRole(id: string): Promise<void> {
    await this.delete(`auth/roles/${id}`)
  }
}
